document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('[data-nav-toggle]');
  var links = document.querySelector('[data-nav-links]');
  if (toggle && links) {
    toggle.addEventListener('click', function () {
      links.classList.toggle('is-open');
    });
  }
  document.querySelectorAll('[data-qty-selector]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    var minus = wrap.querySelector('[data-qty-minus]');
    var plus = wrap.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', function () {
      input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
    });
    if (plus) plus.addEventListener('click', function () {
      input.value = parseInt(input.value || '1', 10) + 1;
    });
  });
});
